import SharingDialog, { ShareProps } from './SharingDialog';
import { closeSharingDialog } from '../actions/internalActions';
import { SharingDialogStore } from '../store/schema/SharingDialogStore';
import { SharingDialogResponse } from '../types/SharingDialogResponse';
import { observer } from 'mobx-react-lite';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import * as React from 'react';

const styles = require('./sharingDialog.scss');

export interface ShareModalProps {
    shareProps: ShareProps;
    sharingDialogStore: SharingDialogStore;
    onDismiss: (result?: SharingDialogResponse) => void;
}

const ShareModal = observer(function ShareModal(props: ShareModalProps) {
    return (
        <Modal
            className={styles.sharingDialog}
            isOpen={props.sharingDialogStore.viewState.isOpen}
            onDismiss={closeSharingDialog}>
            <SharingDialog onDismiss={props.onDismiss} {...props.shareProps} />
        </Modal>
    );
});
export default ShareModal;
